var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"add-text-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"add-text-icon",attrs:{"size":"16"}},[_vm._v(_vm._s(_vm.icon))]),_c('span',[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }